<template>
    <v-container fluid>
        <v-card class="px-6 py-3 br-15 w-100" elevation="0">
            <v-row no-gutters class="pt-2" align="start">
                <v-col cols="6">
                    <v-toolbar-title class="page-title">
                        Planograma Cubo + Fila Única
                    </v-toolbar-title>
                </v-col>
                <v-col cols="6">
                            <div class="d-flex justify-end flex-nowrap" style="gap: 8px; width: 100%;">
                                <MesInput label="Mes" v-model="mes" :rules="regra.mes" :change="mudouMes" required />
                                <v-btn class="new-button flex-shrink-0" color="primary" @click="exportarPlanogramas">
                                    <v-icon left>mdi-download</v-icon> Exportar
                                </v-btn>
                            </div>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                                v-model="buscaPlanograma"
                                label="Buscar grupo ou cluster..."
                                outlined
                                dense
                                clearable
                                hide-details
                                append-icon="mdi-magnify"
                                class="input-button input-cinza"
                            >
                                <template>
                                    <v-icon slot="append" color="white">mdi-magnify</v-icon>
                                </template>
                            </v-text-field>
                </v-col>
                <v-col cols="6" >
                     <div class="d-flex justify-end flex-nowrap" style="gap: 8px; width: 100%;">
                    <v-btn
                                    class="new-button btn-imagens-clusters flex-shrink-1"
                                    color="primary"
                                    @click="associarImagensTodosClusters('Avulsos')"
                                >
                                    <v-icon x-small left style="margin-right:4px;">mdi-file-replace</v-icon>
                                    <span class="btn-imagens-text"><span>Imagens</span><br><span>Avulsas</span></span>
                                </v-btn>
                                <v-btn
                                    class="new-button btn-imagens-clusters flex-shrink-1"
                                    color="primary"
                                    @click="associarImagensTodosClusters('Pastas')"
                                >
                                    <v-icon x-small left style="margin-right:4px;">mdi-file-replace</v-icon>
                                    <span class="btn-imagens-text"><span>Imagens</span><br><span>Por Pasta</span></span>
                                </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <!-- Grid de planogramas -->
        <v-card class="px-6 py-4 br-15 w-100 mt-4" elevation="0" v-if="planogramasExistentes.length > 0">
            <!-- se grupo for vazio: -->

            <!-- se grupo for vazio: -->
            <div v-for="grupo in planogramasAgrupados" :key="grupo.label" class="mb-8">
                <div class="d-flex align-center mb-3">
                    <span class="page-title">{{ grupo.label }}</span>
                </div>
                <v-divider class="mb-4" />
                <v-row>
                    <v-col v-for="item in grupo.clusters" :key="item.id_cluster + '|' + (item.regiao || 'PADRAO')" style="max-width: 20%">
                        <v-card class="planograma-card br-10" elevation="1">
                            <div class="planograma-img-wrap" style="cursor: zoom-in" @click="abrirModalFoto(item)">
                                <v-img
                                    v-if="item.planograma"
                                    :src="$arquivoProtegido(item.planograma)"
                                    aspect-ratio="1"
                                    class="planograma-img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                            <v-progress-circular indeterminate color="grey lighten-1" />
                                        </v-row>
                                    </template>
                                </v-img>
                                <div v-else class="planograma-sem-img d-flex align-center justify-center">
                                    <v-icon size="48" color="grey lighten-1">mdi-image-off-outline</v-icon>
                                </div>
                            </div>
                            <div class="planograma-card-footer pa-3">
                                <div class="font-weight-bold text-subtitle-2 text--primary">
                                    {{ item.cluster }}
                                </div>
                                <v-chip
                                    v-if="item.is_regional"
                                    x-small
                                    color="primary lighten-4"
                                    class="mt-1 font-weight-medium"
                                >
                                    <v-icon x-small left>mdi-map-marker</v-icon>{{ item.regiao_label }}
                                </v-chip>
                                <div class="d-flex align-center mt-1">
                                    <v-icon size="10" :color="item.planograma ? 'success' : 'grey'" class="mr-1"
                                        >mdi-circle</v-icon
                                    >
                                    <span class="caption grey--text text--darken-1">{{ item.tipo }}</span>
                                </div>
                                <div class="d-flex mt-2" style="gap: 6px">
                                    <v-btn
                                        x-small
                                        color="primary lighten-3"
                                        class="new-button flex-grow-1 planograma-btn"
                                        @click="abrirInputIndividual(item, grupo.label)"
                                    >
                                       
                                        {{ item.planograma ? 'Alterar' : 'Adicionar' }}
                                    </v-btn>
                                    <v-btn
                                        small
                                        color="error lighten-2"
                                        class="new-button planograma-btn"
                                        :disabled="!item.planograma"
                                        @click="confirmarExclusao(item)"
                                    >
                                       Excluir
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-alert v-if="planogramasAgrupados.length === 0" class="mt-4" text type="info">
                Nenhum acordo cadastrado para o período selecionado
            </v-alert>

        <!-- Modal confirmação exclusão -->
        <v-dialog content-class="br-15" v-model="dialogExclusao" width="700">
            <v-card>
                <v-toolbar elevation="0" dark class="error white--text fix-flex">
                    <v-toolbar-title>Excluir planograma</v-toolbar-title>
                    <v-spacer />
                    <v-btn fab width="24px" height="24px" elevation="0" light @click="dialogExclusao = false">
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4" v-if="itemParaExcluir">
                    Deseja realmente <span style="color: red">excluir</span> o planograma do cluster <br /><br />
                    <strong>{{ itemParaExcluir.cluster }}</strong>
                    <span> do grupo </span>
                    <strong>{{ itemParaExcluir.label }}</strong>
                    <template v-if="itemParaExcluir.is_regional">
                        <span> da região </span>
                        <strong>{{ itemParaExcluir.regiao_label }}</strong>
                    </template>
                    ? <br /><br />
                    Esta ação não pode ser desfeita.
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey" outlined text class="new-button mr-3 px-4 mb-2" @click="dialogExclusao = false">
                        <v-icon class="mr-3">mdi-close-circle</v-icon> Fechar
                    </v-btn>
                    <v-btn class="new-button px-4 mb-2" color="error" outlined @click="excluirPlanograma">
                        <v-icon class="mr-3">mdi-delete</v-icon> Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal visualização -->
        <v-dialog v-model="dialogFoto" max-width="700">
            <v-card class="br-15" v-if="fotoSelecionada">
                <v-card-title class="subtitle-1 primary white--text d-flex justify-space-between align-center">
                    <span>{{ fotoSelecionada.cluster }}</span>
                    <v-btn icon dark @click="dialogFoto = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <div class="text-caption grey--text mb-3">
                        {{ fotoSelecionada.label }}
                    </div>
                    <v-img :src="$arquivoProtegido(fotoSelecionada.planograma)" contain max-height="500">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="primary" />
                            </v-row>
                        </template>
                    </v-img>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>

        <v-snackbar v-model="alerta" :color="alertaColor" :timeout="3000" top style="z-index: 400">
            <v-alert :type="alertaColor">{{ alertaTexto }}</v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">Fechar</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
    name: 'planogramas_clusters',
    data() {
        return {
            mes: this.$moment().format('YYYY-MM'),
            mesAtual: this.$moment().format('YYYY-MM'),
            regra: {
                mes: [
                    (v) => !!v || 'O campo mês é obrigatório',
                    (v) => (v && v >= this.mesAtual) || 'O período deve ser igual ou posterior ao mês atual',
                ],
            },
            carregando: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            planogramasExistentes: [],
            buscaPlanograma: '',
            dialogFoto: false,
            fotoSelecionada: null,
            dialogExclusao: false,
            itemParaExcluir: null,
        }
    },
    computed: {
        planogramasAgrupados() {
            const busca = (this.buscaPlanograma || '').toLowerCase().trim()
            const grupos = {}
            for (const item of this.planogramasExistentes) {
                const matchGrupo = item.label.toLowerCase().includes(busca)
                const matchCluster = item.cluster.toLowerCase().includes(busca)
                if (busca && !matchGrupo && !matchCluster) continue
                if (!grupos[item.label]) {
                    grupos[item.label] = { label: item.label, clusters: [] }
                }
                grupos[item.label].clusters.push(item)
            }
            return Object.values(grupos)
        },
    },
    methods: {
                                abrirInputIndividual(item, grupo_macro) {
                                    const input = document.createElement('input');
                                    input.type = 'file';
                                    input.accept = 'image/*,.pdf';
                                    input.onchange = (event) => {
                                        const files = Array.from(event.target.files);
                                        if (!files.length) return;

                                        // Payload igual ao lote, mas só para esse cluster
                                        const payload = [{
                                            mes: item.mes,
                                            tipo: item.tipo,
                                            id_clusters: [Number(item.id_cluster)],
                                            grupo_macro: grupo_macro,
                                            id_espaco: item.id_espaco,
                                            regiao: item.regiao || 'PADRAO'
                                        }];

                                        const formData = new FormData();
                                        formData.append('files', files[0]);
                                        formData.append('payloads', JSON.stringify(payload));

                                        // CUBO usa o fluxo por região (TS); Fila Única segue no fluxo antigo
                                        const url = item.tipo === 'CUBO'
                                            ? '/planogramasclustersregiao/salvargrupo'
                                            : '/planogramasclusters/salvargrupo';

                                        this.carregando = true;
                                        this.$http().post(url, formData)
                                            .then(response => {
                                                this.carregando = false;
                                                if (response.data.sucesso) {
                                                    this.mostrarAlerta('Planograma salvo com sucesso!', 'success');
                                                } else if (response.data.resultados) {
                                                    const erros = response.data.resultados.filter(r => r.sucesso === 0).map(r => r.erro).join('\n');
                                                    if (erros) this.mostrarAlerta(erros, 'error');
                                                } else {
                                                    this.mostrarAlerta(response.data.erros?.[0]?.msg || 'Erro ao salvar.', 'error');
                                                }
                                                this.busqueDadosIniciais(this.mes);
                                            })
                                            .catch(() => {
                                                this.carregando = false;
                                                this.mostrarAlerta('Erro ao salvar.', 'error');
                                            });
                                    };
                                    input.click();
                                },
                        // Função utilitária para normalizar nomes (remove acentos, espaços, deixa minúsculo)
                        normalizar(str) {
                            str = String(str || '');
                            return str
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '') // remove acentos
                                .replace(/[^a-zA-Z0-9]/g, '') // remove caracteres especiais e espaços
                                .toLowerCase();
                        },

                        // Função para mapear nome do arquivo para nome oficial do cluster
                        mapearNomeArquivoParaCluster(nomeArquivo) {
                            const nomeNorm = this.normalizar(nomeArquivo);
                            const match = nomeNorm.match(/^cubo([0-9]+)(.*)$/);
                            if (!match) return nomeArquivo;
                            const numero = match[1];
                            let distincao = match[2] || '';
                            distincao = distincao.replace(/superpopular|superpop|popular|supernobre|nobre|hibrida|ampla/, (d) => {
                                if (d === 'superpop' || d === 'superpopular') return 'SUPER POPULAR';
                                if (d === 'popular') return 'POPULAR';
                                if (d === 'hibrida') return 'HÍBRIDA';
                                if (d === 'nobre') return 'NOBRE';
                                if (d === 'supernobre') return 'SUPER NOBRE';
                                if (d === 'ampla') return 'AMPLA';
                                return d.toUpperCase();
                            });
                            let base = '';
                            if (numero === '1') base = 'CUBO CAMPANHA';
                            else if (numero === '2') base = 'CUBO SAZONAL';
                            else if (numero === '3') base = 'CUBO COOPERADO';
                            else if (numero === '4') base = 'CUBO MARCA PROPRIA';
                            else base = `CUBO ${numero}`;
                            return `${base} ${distincao.trim()}`.replace(/\s+/, ' ').trim();
                        },
                        // Normaliza preservando fronteiras de palavra (espaço único, sem acento, minúsculo)
                        normalizarComEspacos(str) {
                            return String(str || '')
                                .normalize('NFD')
                                .replace(/[̀-ͯ]/g, '')
                                .replace(/[^a-zA-Z0-9]+/g, ' ')
                                .replace(/\s+/g, ' ')
                                .trim()
                                .toLowerCase();
                        },
                        // Extrai { grupo_macro, clusterNome, regiao } do nome do arquivo no
                        // padrão "cubo<N> <cluster> <regiao>". Sem região no nome => regiao vazia (Geral).
                        parseNomeArquivoPlanograma(nomeArquivo) {
                            const norm = this.normalizarComEspacos(nomeArquivo);
                            const cuboIdx = norm.indexOf('cubo');
                            if (cuboIdx < 0) return null;
                            // trecho após a palavra "cubo"
                            let resto = norm.slice(cuboIdx + 'cubo'.length).trim();
                            let grupo_macro;
                            let grupo_alternativo;
                            const numMatch = resto.match(/^(\d+)/);
                            if (numMatch) {
                                // forma numérica: "cubo 2 ..."
                                const numero = numMatch[1];
                                if (numero === '1') grupo_macro = 'CUBO CAMPANHA';
                                else if (numero === '2') grupo_macro = 'CUBO SAZONAL';
                                else if (numero === '3') grupo_macro = 'CUBO COOPERADO';
                                else if (numero === '4') grupo_macro = 'CUBO MARCA PROPRIA';
                                else grupo_macro = `CUBO ${numero}`;
                                grupo_alternativo = `CUBO ${numero} INFERIOR/SUPERIOR`;
                                resto = resto.slice(numMatch[0].length).trim();
                            } else {
                                // forma textual: "cubo sazonal ...", "cubo marca propria ..."
                                // (mais longos primeiro p/ não casar parcial)
                                const cubosTexto = [
                                    ['marca propria', 'CUBO MARCA PROPRIA'],
                                    ['campanha', 'CUBO CAMPANHA'],
                                    ['sazonal', 'CUBO SAZONAL'],
                                    ['cooperado', 'CUBO COOPERADO'],
                                    ['topo 1', 'CUBO TOPO 1'],
                                    ['topo 2', 'CUBO TOPO 2'],
                                    ['topo', 'CUBO TOPO'],
                                ];
                                const def = cubosTexto.find(([kw]) => resto.startsWith(kw));
                                if (!def) return null;
                                grupo_macro = def[1];
                                resto = resto.slice(def[0].length).trim();
                            }
                            // clusters: mais longos primeiro para não casar parcial (super popular antes de popular)
                            const clusterDefs = [
                                ['super popular', 'SUPER POPULAR'],
                                ['super nobre', 'SUPER NOBRE'],
                                ['popular', 'POPULAR'],
                                ['hibrida', 'HIBRIDA'],
                                ['nobre', 'NOBRE'],
                                ['ampla', 'AMPLA'],
                            ];
                            for (const [kw, nome] of clusterDefs) {
                                const idx = resto.indexOf(kw);
                                if (idx > -1) {
                                    // tudo após a palavra-chave do cluster = região
                                    let regiao = resto.slice(idx + kw.length).trim();
                                    regiao = regiao.replace(/^(regiao|regional|reg)\s+/, '').trim();
                                    return { grupo_macro, grupo_alternativo, clusterNome: nome, regiao };
                                }
                            }
                            return null;
                        },
                associarImagensTodosClusters(tipo) {
                    // Importação em lote por nome de arquivo: "cubo<N> <cluster> <regiao>".
                    // Sem região no nome => slot Geral. Inclui também os cards regionais.
                    const clustersNaPagina = this.planogramasAgrupados.flatMap(grupo =>
                        grupo.clusters.map(c => ({
                            id_cluster: c.id_cluster,
                            grupo_macro: grupo.label,
                            mes: c.mes,
                            tipo: c.tipo,
                            id_espaco: c.id_espaco,
                            regiao: c.regiao || 'PADRAO',
                            is_regional: !!c.is_regional,
                            nome_completo_norm: this.normalizar(`${grupo.label} ${c.cluster}`),
                            regiao_norm: this.normalizar(c.regiao || '')
                        })));
                    if (!clustersNaPagina.length) return;
                    const input = document.createElement('input');
                    if (tipo === 'Pastas') {
                        input.webkitdirectory = true;
                    } else {
                        input.multiple = true;
                    }
                    input.type = 'file';
                    input.accept = 'image/*,.pdf';
                    input.multiple = true;
                    input.onchange = (event) => {
                        const files = Array.from(event.target.files);
                        const arquivosValidos = [];
                        const payloads = [];
                        const naoCasados = [];
                        files.forEach(file => {
                            const nomeArquivo = file.name.split('.')[0];
                            const parsed = this.parseNomeArquivoPlanograma(nomeArquivo);
                            if (!parsed) {
                                naoCasados.push(file.name);
                                return;
                            }
                            const cuboClusterNorm = this.normalizar(`${parsed.grupo_macro} ${parsed.clusterNome}`);
                            const regiaoArquivoNorm = this.normalizar(parsed.regiao || '');
                            let candidatos = clustersNaPagina.filter(c => c.nome_completo_norm === cuboClusterNorm);
                            if (!candidatos.length && parsed.grupo_alternativo) {
                                const alternativoNorm = this.normalizar(`${parsed.grupo_alternativo} ${parsed.clusterNome}`);
                                candidatos = clustersNaPagina.filter(c => c.nome_completo_norm === alternativoNorm);
                            }
                            if (!candidatos.length) {
                                naoCasados.push(file.name);
                                return;
                            }
                            let card;
                            if (!regiaoArquivoNorm) {
                                // sem região no nome => slot Geral
                                card = candidatos.find(c => !c.is_regional);
                            } else {
                                // 1) igualdade exata da região
                                card = candidatos.find(c => c.is_regional && c.regiao_norm === regiaoArquivoNorm);
                                if (!card) {
                                    // 2) tolera contenção, desde que não seja ambíguo
                                    const contidos = candidatos.filter(c =>
                                        c.is_regional &&
                                        (regiaoArquivoNorm.includes(c.regiao_norm) || c.regiao_norm.includes(regiaoArquivoNorm)));
                                    if (contidos.length === 1) card = contidos[0];
                                }
                            }
                            if (!card) {
                                naoCasados.push(file.name);
                                return;
                            }
                            arquivosValidos.push(file);
                            payloads.push({
                                mes: card.mes,
                                tipo: card.tipo,
                                id_clusters: [Number(card.id_cluster)],
                                grupo_macro: card.grupo_macro,
                                id_espaco: card.id_espaco,
                                regiao: card.regiao
                            });
                        });
                        if (!arquivosValidos.length) {
                            this.mostrarAlerta(
                                'Nenhum arquivo corresponde a um cubo/cluster/região da página.' +
                                    (naoCasados.length ? ` Não reconhecidos: ${naoCasados.join(', ')}` : ''),
                                'error',
                            );
                            return;
                        }
                        const formData = new FormData();
                        arquivosValidos.forEach(file => formData.append('files', file));
                        formData.append('payloads', JSON.stringify(payloads));
                        this.carregando = true;
                        // Lote mapeia somente cubos (por nome de arquivo) -> fluxo por região (TS)
                        this.$http().post('/planogramasclustersregiao/salvargrupo', formData)
                            .then(response => {
                                this.carregando = false;
                                const avisos = naoCasados.length
                                    ? [`Arquivos não reconhecidos: ${naoCasados.join(', ')}`]
                                    : [];
                                if (response.data.resultados) {
                                    const erros = response.data.resultados.filter(r => r.sucesso === 0).map(r => r.erro);
                                    const msgs = [...erros, ...avisos];
                                    if (msgs.length) this.mostrarAlerta(msgs.join('\n'), erros.length ? 'error' : 'warning');
                                    else this.mostrarAlerta('Planograma(s) salvo(s) com sucesso!', 'success');
                                } else if (response.data.sucesso) {
                                    this.mostrarAlerta([...avisos, 'Planograma(s) salvo(s) com sucesso!'].join('\n'), avisos.length ? 'warning' : 'success');
                                } else {
                                    this.mostrarAlerta(response.data.erros?.[0]?.msg || 'Erro ao salvar.', 'error');
                                }
                                this.busqueDadosIniciais(this.mes);
                            })
                            .catch(() => {
                                this.carregando = false;
                                this.mostrarAlerta('Erro ao salvar.', 'error');
                            });
                    };
                    input.click();
                },
        mudouMes(mes) {
            this.busqueDadosIniciais(mes)
        },
        abrirModalFoto(item) {
            if (!item.planograma) return
            this.fotoSelecionada = item
            this.dialogFoto = true
        },
        abrirInput(item) {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*,.pdf'
            input.onchange = (event) =>
                this.salvarPlanograma(event, {
                    mes: item.mes,
                    tipo: item.tipo,
                    label: item.label,
                    id_espaco: item.id_espaco,
                    clusters: [item.id_cluster],
                })
            input.click()
        },

        abrirInputGrupo(grupo) {
            const input = document.createElement('input')
            console.log(grupo)
            input.type = 'file'
            input.multiple = true
            input.onchange = (event) =>
                this.salvarPlanograma(event, {
                    mes: grupo.clusters[0].mes,
                    tipo: grupo.clusters[0].tipo,
                    label: grupo.label,
                    id_espaco: grupo.clusters[0].id_espaco,
                    clusters: grupo.clusters.map((c) => c.id_cluster),
                })
            input.click()
        },
        async salvarPlanograma(event, item) {
            const files = event.target.files;
            if (!files || files.length === 0) return;

            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
            }
            formData.append('mes', item.mes); // <-- vem do banco, não do estado do componente
            formData.append('tipo', item.tipo);
            formData.append('id_clusters', JSON.stringify(item.clusters)); // sempre array
            formData.append('grupo_macro', item.tipo === 'CUBO' ? item.label : '');
            formData.append('id_espaco', item.tipo === 'FILA_UNICA' ? item.id_espaco : '');

            this.carregando = true;
            const response = await this.$http().post('/planogramasclusters/salvargrupo', formData);
            this.carregando = false;

            if (response.data.sucesso) {
                this.mostrarAlerta('Planograma(s) salvo(s) com sucesso!', 'success');
            } else {
                this.mostrarAlerta(response.data.erros?.[0]?.msg || 'Erro ao salvar.', 'error');
            }

            await this.busqueDadosIniciais(this.mes);
        },
        confirmarExclusao(item) {
            this.itemParaExcluir = item
            this.dialogExclusao = true
        },
        async excluirPlanograma() {
            this.dialogExclusao = false
            this.carregando = true
            const isCubo = this.itemParaExcluir.tipo === 'CUBO'
            const payload = {
                mes: this.itemParaExcluir.mes,
                tipo: this.itemParaExcluir.tipo,
                id_cluster: this.itemParaExcluir.id_cluster,
                grupo_macro: isCubo ? this.itemParaExcluir.label : null,
                fila_value: this.itemParaExcluir.tipo === 'FILA_UNICA' ? this.itemParaExcluir.id_espaco : null,
                regiao: this.itemParaExcluir.regiao || 'PADRAO',
            }

            // CUBO usa o fluxo por região (TS); Fila Única segue no fluxo antigo
            const url = isCubo
                ? '/planogramasclustersregiao/excluirplanograma'
                : '/planogramasclusters/excluirplanograma'

            const response = await this.$http().post(url, payload)

            this.itemParaExcluir = null
            this.carregando = false

            if (response.data.sucesso) {
                this.mostrarAlerta('Planograma excluído com sucesso!', 'success')
            } else {
                this.mostrarAlerta(response.data.erros?.[0]?.msg || 'Erro ao excluir.', 'error')
            }

            await this.busqueDadosIniciais(this.mes)
        },
        async exportarPlanogramas() {
            this.carregando = true
            const response = await this.$http().post('/planogramasclusters/exportar', { mes: this.mes })
            window.location = this.$http('baseURL') + response.data.url
            this.carregando = false
        },
        mostrarAlerta(texto, color = 'error') {
            this.alertaTexto = texto
            this.alertaColor = color
            this.alerta = true
        },
        async busqueDadosIniciais(mes) {
            this.carregando = true
            const response = await this.$http().post('/planogramasclustersregiao/lista', { mes })
            if (response.status !== 200) {
                this.mostrarAlerta('Erro ao carregar dados.', 'error')
                this.carregando = false
                return
            }
            this.planogramasExistentes = response.data || []
            this.carregando = false
        },
    },
    async mounted() {
        this.busqueDadosIniciais(this.mes)
    },
}
</script>

<style scoped>
.btn-imagens-clusters {
    min-width: 0;
    width: 180px;
    padding-left: 12px;
    padding-right: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #26a69a !important;
    color: #fff !important;
    border: none !important;
}
.btn-imagens-text {
    font-size: 0.85rem;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    line-height: 0.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    color: #fff !important;
    transition: font-size 0.2s;
}
@media (max-width: 600px) {
    .btn-imagens-clusters {
        width: 120px;
    }
    .btn-imagens-text {
        font-size: 0.75rem;
    }
}
</style>

<style scoped>
.planograma-card {
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
}

.planograma-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12) !important;
}

.planograma-img-wrap {
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    background-color: #f5f5f5;
}

.planograma-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.planograma-sem-img {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
}

.planograma-card-footer {
    border-top: 1px solid #eeeeee;
    background-color: #ffffff;
}

.br-10 {
    border-radius: 10px !important;
}

.planograma-btn {
    min-height: 36px;
    text-transform: none;
}

.planograma-btn-delete {
    min-width: 120px;
    font-weight: 600;
}
</style>

